import api from "./api";
const http = (url, params, type) => {
	let fn;
	switch (type) {
		case "post":
			fn = api.post(url, params);
			break;
		case "get":
			fn = api.get(url, params);
			break;
		default:
			fn = api.get(url, params);
	}
	return fn;
};
export default http;
